import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@common-web/components/ui/select';
import {US_STATES, getStateName} from '@common/constants/usStates';

export {getStateName};

export function StateSelect({
  value,
  onValueChange,
  disabled,
  placeholder = 'Select state',
  className,
  id,
}: {
  value: string;
  onValueChange: (value: string) => void;
  disabled?: boolean;
  placeholder?: string;
  className?: string;
  id?: string;
}) {
  return (
    <Select value={value || undefined} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger id={id} className={className}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {US_STATES.map((s) => (
          <SelectItem key={s.code} value={s.code}>
            {s.code} - {s.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
